import { useState } from 'react';
import { useTranslation } from 'next-i18next';
import router from 'next/router';
import styles from '@components/Message/MessageMobile.styles';
import Icon from '@components/icons/Icon';
import Button from '@components/Button/Button';
import MessageTimeBar from '@components/Message/MessageTimeBar';
import theme from '@styles/theme';
type PropsType = {
  message: React.ReactNode;
  onClose: VoidFunction;
  backgroundColor?: string;
  color?: string;
  displayBarTime?: number;
  isOnCloseAnimation?: boolean;
  attachRefreshLink?: boolean;
};
const MessageMobile = ({
  message,
  onClose,
  backgroundColor = theme.rawColors.dirtyPink200,
  color = theme.rawColors.darkGrey700,
  displayBarTime = 0,
  isOnCloseAnimation = true,
  attachRefreshLink = false
}: PropsType) => {
  const [closed, setClosed] = useState(false);
  const {
    t
  } = useTranslation('common');
  const handleRefresh = () => {
    router.reload();
  };
  const handleCloseMessage = () => {
    if (isOnCloseAnimation) setClosed(true);
    setTimeout(onClose, 300);
  };
  return <div sx={styles.containerMobile(closed, backgroundColor, color)} data-cy="CartMessageMobile" role="alert">
      <div sx={styles.infoIconStyles(closed)}>
        <Icon icon="InfoOutline" size="24px" />
      </div>
      <div sx={styles.message(closed)}>
        {message}{' '}
        {attachRefreshLink && <div sx={styles.refresh} onClick={handleRefresh} onKeyDown={e => e.key === 'Enter' && handleRefresh()} role="button" tabIndex={0}>
            {t('alerts.configurator.clickToRefresh')}
          </div>}
      </div>
      <div sx={styles.closeButtonStyles(closed)}>
        <Button variant="iconOnly" sx={styles.buttonStyles(closed)} onClick={handleCloseMessage}>
          <Icon icon="Close2" size="16px" />
        </Button>
      </div>
      {displayBarTime > 0 && <MessageTimeBar displayTime={displayBarTime} />}
    </div>;
};
export default MessageMobile;